<app-product-trading-set-configurator-widget [productId]="productId()" />
